module.exports = __webpack_public_path__ + "static/media/prefill-gif-navy-blue.08a55587.gif";